import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";
import { isWebVitalsExcludedRoute } from "@stanza/shared/performance-analytics";
import { customEvent } from "./gtag.js";
import { getWebVitalsRoute } from "../services/Config.js";

const WEB_VITALS_CATEGORY = "Web Vitals";

const getGAValue = ({ name, delta }) => (
  Math.round(name === "CLS" ? delta * 1000 : delta)
);

export const buildWebVitalsEventData = (metric, route, visibilityStateAtLoad) => ({
  value: getGAValue(metric),
  metric_id: metric.id,
  metric_name: metric.name,
  metric_value: metric.value,
  metric_delta: metric.delta,
  metric_rating: metric.rating,
  metric_navigation_type: metric.navigationType,
  visibility_state_at_load: visibilityStateAtLoad,
  web_vitals_route: route,
  non_interaction: true,
  transport_type: "beacon",
});

export const sendWebVitalsMetric = (metric, route, visibilityStateAtLoad) => {
  customEvent({
    name: metric.name,
    category: WEB_VITALS_CATEGORY,
    action: metric.name,
    label: metric.id,
    data: buildWebVitalsEventData(metric, route, visibilityStateAtLoad),
  });
};

export const reportWebVitals = () => {
  if (process.env.NODE_ENV !== "production") return;

  const route = getWebVitalsRoute(window.location.pathname);
  if (isWebVitalsExcludedRoute(route)) return;
  // Captured at init: background tabs defer paint, so FCP/LCP are only
  // comparable across loads that started in the same visibility state.
  const visibilityStateAtLoad = document.visibilityState;
  const sendMetric = (metric) => sendWebVitalsMetric(metric, route, visibilityStateAtLoad);

  onCLS(sendMetric);
  onINP(sendMetric);
  onLCP(sendMetric);
  onFCP(sendMetric);
  onTTFB(sendMetric);
};
